import { IG6GraphEvent } from '@antv/g6';
import { Group, Item, NodeModel, Shape } from 'ui/workflows/flowchart/types';
import { GroupName } from '../../../constants';

export const isChildNodeGroup = (item: Group | Shape) =>
  item?.isGroup() && item?.get('name') === GroupName.ChildNode;

export const getChildNodeGroupFromEvent = ({ propagationPath = [] }: IG6GraphEvent) =>
  propagationPath.find((item) => isChildNodeGroup(item));

export const getChildNodeDataFromGroup = (group: Group, item: Item) => {
  if (!isChildNodeGroup(group)) return { data: null, index: -1 };

  const model = item?.getModel() as NodeModel;
  const index = group?.get('index') ?? -1;
  const data = model?.nodeData?.childNodes?.[index] ?? null;

  return { data, index };
};
